import { useEffect } from 'react';
import { Platform } from 'react-native';
import {
  useSharedValue,
  useAnimatedStyle,
  withTiming,
  withDelay,
  Easing,
} from 'react-native-reanimated';

import { animation } from '../tokens';

export function useFadeIn(delay = 0, duration = animation.normal, trigger?: number) {
  // Start fully visible and replay on trigger changes.
  const opacity = useSharedValue(1);
  const translateY = useSharedValue(0);

  useEffect(() => {
    const isAndroidQuestionTransition = Platform.OS === 'android' && trigger !== undefined;
    const startOpacity = isAndroidQuestionTransition ? 1 : 0.4;

    // Reset to start position, then animate in. Use reanimated delay instead of JS timeout
    // so the completion animation can proceed even when the JS thread is briefly busy.
    opacity.value = startOpacity;
    translateY.value = 4;
    const effectiveDelay = Math.max(delay, 16);
    opacity.value = withDelay(
      effectiveDelay,
      withTiming(1, { duration, easing: Easing.out(Easing.cubic) })
    );
    translateY.value = withDelay(
      effectiveDelay,
      withTiming(0, { duration, easing: Easing.out(Easing.cubic) })
    );
    return undefined;
  }, [trigger]); // Only re-run on trigger change (question index), not on delay/duration

  const animatedStyle = useAnimatedStyle(() => ({
    opacity: opacity.value,
    transform: [{ translateY: translateY.value }],
  }));

  return animatedStyle;
}
